<template>
  <div
    class="news-inner-wrapper wc"
    v-if="this.$store.state.main.current_content_request_status === 'done'"
  >
    <portal to="modal">
      <transition name="fadeoverlay">
        <div class="white-overlay" v-if="!newsLoaded"></div>
      </transition>
    </portal>
    <div class="container-landing news-pic-wrapper">
      <div class="tb-sticker" v-html="main_data.cover_svg"></div>
      <div class="go-back-row">
        <!-- <a class="back-btn" @click="$router.go(-1)"> -->
        <a class="back-btn" @click="$router.back()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.62"
            height="15.07"
            viewBox="0 0 20.62 15.07"
          >
            <g
              id="Group_104"
              data-name="Group 104"
              transform="translate(0.534 0.535)"
            >
              <g id="menu" transform="translate(0 0)">
                <g
                  id="Group_103"
                  data-name="Group 103"
                  transform="translate(0 0)"
                >
                  <path
                    id="Union_6"
                    data-name="Union 6"
                    d="M9.062.879a37.229,37.229,0,0,0,4.729,3.3c.457.271.925.53,1.407.755-.7.029-1.409,0-2.113-.029-.748-.031-1.487-.06-2.194-.025-3.048.165-6.065.724-9.125.666-1.052-.017-2.779,1.559-1,1.592,3.468.064,6.869-.624,10.328-.7.573-.011,1.159,0,1.752.016a19,19,0,0,0,3.911-.186,56.985,56.985,0,0,0-5.136,5.369c-.442.6-.091,1.6.513.767,1.772-2.432,4.258-4.2,6.158-6.521a1,1,0,0,0,.158-.271.794.794,0,0,0,.25-.608c0-.027,0-.052,0-.075-.015-.457-.669-.551-1.321-.4A9.019,9.019,0,0,1,13.969,2.97a41.86,41.86,0,0,1-3.9-2.78A.9.9,0,0,0,9.5,0C8.967,0,8.481.4,9.062.879Z"
                    transform="matrix(-0.998, -0.07, 0.07, -0.998, 18.659, 14.001)"
                    fill="#101820"
                    stroke="#101820"
                    stroke-width="1"
                  />
                </g>
              </g>
            </g>
          </svg>

          <span class="f-21 bold-italic">{{ $fn.tr("უკან") }}</span>
        </a>
      </div>
      <div class="news-pic-block">
        <img
          class="main-pic"
          :src="main_data.cover[0].url"
          :alt="get_alt(main_data)"
          v-if="main_data.cover[0]"
        />
      </div>
    </div>
    <div class="container-news-inner text-editor">
      <div class="ttl-wrapper">
        <span class="f-21 date-row to-lowercase">{{ get_date }}</span>
        <h2 class="f-34 bold ttl">{{ main_data.title }}</h2>
      </div>
      <div class="teaser_1" v-html="main_data.teaser"></div>

      <div
        class="news-img-container"
        v-if="main_data.teaser_image[0] || main_data.teaser_image[1]"
        :class="{ singlepic: main_data.teaser_image.length < 2 }"
      >
        <img
          :src="main_data.teaser_image[0].url"
          alt=""
          class="img-left"
          v-if="main_data.teaser_image[0]"
        />
        <img
          :src="main_data.teaser_image[1].url"
          alt=""
          class="img-right"
          v-if="main_data.teaser_image[1]"
        />
        <div
          class="center-sticker"
          v-html="main_data.teaser_svg"
          :class="{
            top_right: main_data.svg_position == 'top_right',
            top_left: main_data.svg_position == 'top_left',
            bottom_left: main_data.svg_position == 'bottom_left',
            bottom_right: main_data.svg_position == 'bottom_right'
          }"
        ></div>
      </div>

      <div class="teaser_2" v-html="main_data.teaser2"></div>

      <div class="img-with-text">
        <div class="left-col">
          <img
            :src="main_data.teaser3_images[0].url"
            class="left-col-pic"
            alt=""
            v-if="main_data.teaser3_images[0]"
          />
          <div
            class="left-col-sticker"
            v-html="main_data.teaser3_svg"
            :class="{
              top_right: main_data.svg_position3 == 'top_right',
              top_left: main_data.svg_position3 == 'top_left',
              bottom_left: main_data.svg_position3 == 'bottom_left',
              bottom_right: main_data.svg_position3 == 'bottom_right'
            }"
          ></div>
        </div>
        <div class="right-col">
          <div class="teaser_3" v-html="main_data.teaser3"></div>
        </div>
      </div>
    </div>

    <HistorySlider :slideData="main_data" />
    <ShareRow />
  </div>
</template>

<script>
import moment from "../../helpers/moment";
import HistorySlider from "@/components/HistorySlider";
import ShareRow from "@/components/smartComponents/ShareRow";
export default {
  components: { HistorySlider, ShareRow },
  props: ["contentData"],
  data() {
    return {
      newsLoaded: false
    };
  },
  computed: {
    curr_content() {
      return this.$store.state.main.current_content;
    },
    main_data() {
      return this.$store.state.main.current_content.primary.data.list[0];
    },
    curr_status() {
      return this.$store.state.main.current_content_request_status;
    },
    get_date() {
      let d = this.$store.state.main.current_content.primary.data.list[0].date;
      if (this.$route.name === "ge") moment.locale("ka");

      if (this.$route.name == "ge") {
        return moment(d)
          .locale("ka")
          .format("DD MMM YYYY");
      } else if (this.$route.name == "en") {
        return moment(d)
          .locale("en")
          .format("DD MMM YYYY");
      }
    }
  },
  watch: {
    $route(to, from) {
      if (window.innerWidth >= 1024) {
        this.$store.state.main.updateLs3 = !this.$store.state.main.updateLs3;
      }
      console.log("route changed");

      console.log("hi");
    },
    curr_content(ns, os) {
      document.querySelector("body").classList.add("news-inner-page");
    },
    curr_status(ns, os) {
      if (ns === "done") {
        if (window.innerWidth >= 1024) {
          this.$store.state.main.updateLs2 = !this.$store.state.main.updateLs2;
        }
        setTimeout(() => {
          this.newsLoaded = true;
        }, 300);
      }
    }
  },
  mounted() {
    document.querySelector("body").classList.add("news-inner-page");
    setTimeout(() => {
      this.newsLoaded = true;
    }, 1200);

    document.addEventListener("DOMContentLoaded", function() {});
    if (window.innerWidth >= 1024) {
      setTimeout(() => {
        this.$store.state.main.updateLs2 = !this.$store.state.main.updateLs2;
      }, 900);
    }
  },

  methods: {
      get_alt(content){
      if(content.seo_title_ge && this.$store.state.main.locale == 'ge'){
        return content.seo_title_ge;
      } else if (content.seo_title_ge && this.$store.state.main.locale == 'en'){
        return content.seo_title_en;

      } else {
          return ' ';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.teaser_1,
.teaser_2,
.teaser_3 {
  &::v-deep p,
  &::v-deep span,
  &::v-deep h1,
  &::v-deep h2,
  &::v-deep h3,
  &::v-deep h4,
  &::v-deep h5,
  &::v-deep h6,
  &::v-deep strong,
  &::v-deep i,
  &::v-deep mark,
  &::v-deep em,
  &::v-deep small,
  &::v-deep del,
  &::v-deep ins,
  &::v-deep sub,
  &::v-deep sup {
    font-size: 21px;
    font-family: "FiraGO-Italic";
    will-change: transform;
  }
  &::v-deep b {
    font-size: 21px;
    font-family: "FiraGO-Bold";
    will-change: transform;
  }
}

.news-inner-page .news-img-container {
  &.singlepic {
    .img-left {
      left: 50%;
      transform: translateX(-50%) rotate(-2deg);
    }
    .center-sticker {
      top: -20px;
      right: 25%;
      left: initial;
      transform: initial;
      &.top_right {
        top: 30px;
        left: initial;
        right: 190px;
        @media (max-width: 1023px) {
          right: 120px;
        }
      }
      &.top_left {
        top: 60px;
        left: 190px;
        right: initial;
        @media (max-width: 1023px) {
          left: 100px;
        }
      }
      &.bottom_left {
        top: initial;
        left: 190px;
        right: initial;
        bottom: 20px;
        @media (max-width: 1023px) {
          left: 130px;
        }
      }
      &.bottom_right {
        top: initial;
        left: initial;
        right: 190px;
        bottom: 20px;
        @media (max-width: 1023px) {
          right: 120px;
        }
      }
    }
  }
}

@media (max-width: 413px) {
  .news-inner-page .tb-sticker {
    &::v-deep svg {
      width: 90px;
    }
  }
}
</style>
<style lang="scss">
.white-overlay {
  position: fixed;
  background-color: white;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  //  opacity: 1;
  transition: 0.5s;
}

.fadeoverlay-enter-active,
.fadeoverlay-leave-active {
  transition-duration: 1s;
  transition-property: opacity;
  transition-timing-function: ease;
  opacity: 0;
}
// .fadeoverlay-enter-active {
//   transition-delay: 0.2s;
// }

.fadeoverlay-enter,
.fadeoverlay-leave-active {
  opacity: 0;
}
</style>
